// Collapses runs of duplicate slashes, leaving a protocol's :// intact. The ^
// alternative comes first so a run at the very start of the string collapses
// fully, rather than having its first slash eaten by [^:].
const collapseSlashes = (url: string) => url.replace(/(^|[^:])\/{2,}/g, '$1/');

// Joins URL segments with exactly one slash between them.
const joinPaths = (...segments: string[]) =>
  collapseSlashes(segments.filter(Boolean).join('/'));

// Prefixes a path with the app's base URL (`base` in vite.config.ts), so paths
// keep working if the app is ever served from a sub-path.
const withBase = (path: string) => joinPaths(import.meta.env.BASE_URL, path);

export { collapseSlashes, joinPaths, withBase };
